// extracted by mini-css-extract-plugin
export default {"wrapper-disabled":"AutoTextarea_wrapper-disabled__bBKuC","textarea-scroll":"AutoTextarea_textarea-scroll__fc0bo"};